import { render, staticRenderFns } from "./StudioIntro.vue?vue&type=template&id=c4f7fe7c&scoped=true&"
import script from "./StudioIntro.vue?vue&type=script&lang=js&"
export * from "./StudioIntro.vue?vue&type=script&lang=js&"
import style0 from "./StudioIntro.vue?vue&type=style&index=0&id=c4f7fe7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7fe7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
